<template>
  <div class="login_f_box">
    <div class="login">
      <div class="login_box">
        <div class="left">
          <div class="left_box">
           
          </div>
        </div>
        <div class="right">
          <div class="top_right_box1">
            <!-- 语言切换 -->
            <el-popover
              placement="bottom"
              popper-class="top_user lan_popover"
              width="70"
              v-model="visible_lan"
              trigger="click"
            >
                <span slot="reference">
                  <span class="lan_icon" v-if="v_lan=='ch' ">简体中文</span>
                  <span class="lan_icon" v-else-if="v_lan=='jp' ">日本語</span>
                  <span class="lan_icon" v-else>English</span>
                  <i v-if="visible_lan" class="el-icon-caret-top u_r_icon2"></i>
                  <i v-else class="el-icon-caret-bottom u_r_icon2"></i>
                </span>
                <div class="u_box">
                  <div class="lan_list_item" @click="lang_fun('ch')">简体中文</div>
                  <div class="lan_list_item" @click="lang_fun('en')">English</div>
                  <div class="lan_list_item" @click="lang_fun('jp')">日本語</div>
                </div>  
            </el-popover>
          </div>

          <div class="tit_top" :class="v_lan == 'jp' ? 'tit_top_jp' : ''" v-if="login_state==1">
            <span class="tit_top_span">{{ $t("main.text181") }}</span>
            <span class="reg_btn" @click="$router.push('/reg')">{{
              $t("main.text31")
            }}</span>
          </div>

          <el-form
            v-if="login_state==1"
            class="form_box"
            label-position="top"
            label-width="130px"
            :model="form"
            @submit.native.prevent
          >
            <div>
              <el-alert
                v-show="reg_box"
                :title="$t('main.text182')"
                type="success"
                show-icon
                class="succ_alert"
                :closable="false"
              >
              </el-alert>

              <el-alert
                v-show="reset_pwd_box"
                :title="$t('main.text183')"
                type="success"
                show-icon
                class="succ_alert"
                :closable="false"
              >
              </el-alert>
            </div>

            <el-form-item>
              <div class="form_tit">{{ $t("main.text184") }}</div>
            </el-form-item>
            <el-form-item :label="$t('main.text185')">
              <el-input v-model.trim="form.email"></el-input>
            </el-form-item>
            <el-form-item :label="$t('main.text186')">
              <!-- <el-input v-model.trim="form.pwd" show-password></el-input> -->
              <!-- <div class="for_pwd" @click="for_pwd_btn">Forgot password?</div> -->
              <el-input
                v-model.trim="form.pwd"
                :type="pwdType == true ? 'password' : 'text'"
              ></el-input>
              <span class="show-pwd" @click="pwdType = !pwdType">
                <img :src="pwdType ? pwd_yes : pwd_no" alt="" />
              </span>

              <div class="for_pwd">
                <span @click="$router.push('/forget_pwd')">{{
                  $t("main.text187")
                }}</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('main.text190')">
              <div class="code_w">
                <el-input
                  class="code_w2"
                  v-model.trim="form.code"
                  @keyup.enter.native="confirm_btn"
                ></el-input>
                <div class="code_w3">
                  <span @click="createCode">{{ code }}</span>
                  <img
                    @click="createCode"
                    class="f_icon"
                    src="../../assets/img/flush_icon.png"
                    alt=""
                  />
                </div>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button class="login_btn" @click="confirm_btn">{{
                $t("main.text38")
              }}</el-button>
            </el-form-item>
          </el-form>

          <!-- 扫码 -->
          <div v-else-if="login_state==2" class="ewm_box" :class="login_state==2&&!two_txt_show?'ewm_box_2':''">
            <div v-if="login_state==2 && two_txt_show && pc_app=='app'" style="height:210px;">&nbsp;</div>
            <template v-if="two_txt_show">
              <div class="ewm_box1">{{$t("login_google.text673")}}</div>
              <div class="ewm_box2">{{$t("login_google.text674")}}</div>
              <div class="ewm_box3">
                <div class="ewm_ody" ref="qrcode1"></div>
              </div>
              <div class="qrcode_secret">
                
                <span>{{ google_secret.substr(0,10) }}</span>
                <span>......</span>
                <span>{{ google_secret.substr(-8,10) }}</span>
                <img src="../../assets/img/login_copy_icon.png" @click="copy_api(google_secret)" alt="">
              </div>
              <div class="ewm_box4">{{$t("login_google.text675")}}</div>
            </template>
            

            <div>
              <div class="label_box">{{ $t('login_google.text677') }}</div>
              <el-input v-model.trim="google_code" @keyup.enter.native="login_btn_sbmt"></el-input>
            </div>
            
            <div style="margin-top: 15px;">
              <el-button class="login_btn" v-if="google_code&&google_code.length==6 " @click="login_btn_sbmt">{{ $t("main.text38") }}</el-button>
              <el-button class="login_btn" v-else>{{ $t("main.text38") }}</el-button>
            </div>

          </div>

        </div>
      </div>

      <!-- 忘记密码 -->
      <el-dialog
        :title="$t('main.text188')"
        :visible.sync="for_pwd_dlg"
        custom-class="dlg"
        append-to-body
        width="640px"
      >
        <div class="dlg_body">
          <div class="d_body">
            <el-form class="dlg_form" label-position="top" label-width="80px">
              <el-form-item :label="$t('main.text185')">
                <el-input v-model.trim="email_addr"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="for_pwd_dlg = false" class="cancel_btn">{{
            $t("main.text7")
          }}</el-button>
          <el-button
            type="primary"
            @click="confirm_btn_fun"
            class="confirm_btn"
            >{{ $t("main.text189") }}</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { login,account_verify,sendEmail } from "@/api/api";
import md5 from "js-md5";
import QRCode from "qrcodejs2";

export default {
  data() {
    return {
      pc_app: this.pcormove._isMobile(),
      pwd_yes: require("../../assets/img/eye_no.png"),
      pwd_no: require("../../assets/img/eye_yes.png"),
      pwdType: true,
      code: "",
      form: {
        email: "",
        pwd: "",
        code: "",
      },
      reg_box: this.$route.query.reg_box,
      reset_pwd_box: this.$route.query.reset_pwd_box,
      for_pwd_dlg: false,
      email_addr: "",
      visible_lan: false,

      login_state:1,//1 2 3
      Google_data:{
        bind_status:0
      },
      google_secret:"",//	String	谷歌密钥
      google_code:"",//	String	谷歌验证码
      two_txt_show:false,

    };
  },
  mounted() {
    this.createCode();
    if (window.location.href.indexOf("?") !== -1) {
      let url = window.location.search.substr(1);
      const check = JSON.parse(window.decodeURIComponent(url));
      if (check) {
        localStorage.setItem("language", "en");
        this.$i18n.locale = "en";

        localStorage.setItem("feb_phone_cc", check.phone_cc);
        localStorage.setItem("feb_phone_num", check.phone_num);

        sessionStorage.setItem("token", check.token);
        sessionStorage.setItem("userid", check.userid);
        sessionStorage.setItem("authInfo", check.authInfo);
        sessionStorage.setItem("username", check.username);
        // kyc_status: KYC状态 0没有 1保存未提交 2 待审核   3一审通过  4审核通过  5审核失败
        // 4审核通过 路由才能跳转
        sessionStorage.setItem("kyc_status", check.kyc_status);
        //邮箱
        sessionStorage.setItem("u_email", check.email);
        // approve_status: 认证状态 0 没有 1待审核 2审核通过 3审核失败
        // 0 3 需要上传才能进入首页
        localStorage.setItem("approve_status", check.approve_status);

        const arr = [
          "1","1-1","1-2","1-3","1-4",
          "2","2-1","2-2","2-3","2-4","2-5","2-6",
          "3","3-1","3-2","3-3","3-4","3-5","3-6","3-7",
          "4","4-1","4-2","4-3","4-4","4-5","4-6","4-7","4-8",
          "5",
          "6",
          "7",
          "8",
          "9","9-1","9-2","9-3","9-4","9-5","9-6","9-7","9-8","9-9","9-10","9-11","9-12","9-13","9-14","9-15","9-16","9-17","9-18","9-19",
          "10",
          "11","11-1","11-2","11-3","11-4","11-5","11-6","11-7","11-8","11-9","11-10",
          "12","12-1","12-2","12-3","12-4","12-5",
          "13","13-1","13-2","13-3","13-4","13-5","13-6"
        ];

        // haveContract 是否有合同
        const haveContract = check.haveContract;
        haveContract && sessionStorage.setItem("haveContract",haveContract);
        
        sessionStorage.setItem("authjson", JSON.stringify(arr));
        sessionStorage.setItem("form_admin","admin");
        // userType 1 主账号； 2子账号
        sessionStorage.setItem("userType","1");

        if (check.approve_status == 0 || check.approve_status == 3) {
          this.$router.push("/upload");
        } else {
          this.$router.push("/");
        }
        
      }
    }

  },
  methods: {
    createCode() {
      var code = "";
      var codeLength = 4;
      var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);
      for (var i = 0; i < codeLength; i++) {
        var index = Math.floor(Math.random() * 9);
        code += random[index];
      }
      this.code = code;
    },
    confirm_btn() {
      if (!this.form.email) {
        return this.message.ismessage("error", this.$t("main.text191"));
      }
      if (!this.form.pwd) {
        return this.message.ismessage("error", this.$t("main.text192"));
      }
      if (!this.form.code) {
        return this.message.ismessage("error", this.$t("main.text193"));
      }
      if (this.form.code != this.code) {
        return this.message.ismessage("error", this.$t("main.text194"));
      }
      // var reg = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,12}$/;
      // if(!reg.test(this.form.pwd)){
      //   this.message.ismessage('error','密码只能为大写字母+小写字母+数字的8至12位字符组合');
      //   this.message.ismessage('error',this.$t('main.text246'));
      //   return false;
      // }
      // 验证谷歌令牌
      login({
        password:md5(this.form.pwd),
        email:this.form.email
      }).then(res=>{
        if(res.data.code==200){
          this.Google_data=res.data.data;
          if(res.data.data.userid){
            sessionStorage.setItem("userid",res.data.data.userid);
          }
          if(res.data.data.token){
            sessionStorage.setItem("token",res.data.data.token);
          }
          this.google_secret=res.data.data.google_secret;
          if(res.data.data.bind_status==0){
            this.login_state=2;
            this.two_txt_show=true;
            this.$nextTick(function(){
              this.qrcodeRender();
            })
          }else if(res.data.data.bind_status==1){
            // this.login_state=3;
            this.login_state=2;
            this.two_txt_show=false;
          }
        }else{
          return this.message.ismessage('error',res.data.msg);
        }
      })
    },
    // 权限 子方法
    Subset_comparison(kyc_status,authjson,ind){
      // 3  4  11

      if(["1","1-1","1-2","1-3","1-4"].some(value => authjson.includes(value))){
        this.$router.push("/");
      }else if(["2","2-1","2-2","2-3","2-4","2-5","2-6"].some(value => authjson.includes(value))){
        this.$router.push("/my_transaction");
      }else if(["5"].some(value => authjson.includes(value))){
        this.$router.push("/otc");
      }else if(["6"].some(value => authjson.includes(value))){
        this.$router.push("/private_b_p");
      }else if(["7"].some(value => authjson.includes(value))){
        this.$router.push("/structured_p");
      }else if(["8"].some(value => authjson.includes(value))){
        this.$router.push("/investment_b");
      }else if(["9","9-1","9-2","9-3","9-4","9-5","9-6","9-7","9-8","9-9","9-10","9-11","9-12","9-13","9-14","9-15","9-16","9-17","9-18","9-19"].some(value => authjson.includes(value))){
        if(["9","9-1","9-2","9-3","9-4"].some(value => authjson.includes(value))){
          this.$router.push("/contract_management");
        }else if(["9-5","9-6","9-7","9-8","9-9","9-10","9-11","9-12","9-13","9-14","9-15","9-16","9-17","9-18","9-19"].some(value => authjson.includes(value))){
          this.$router.push("/card_management");
        }else if(["12","12-1","12-2","12-3","12-4","12-5"].some(value => authjson.includes(value))){
          this.$router.push("/kycManage");
        }else if(["13","13-1","13-2","13-3","13-4","13-5","13-6"].some(value => authjson.includes(value))){
          // this.$router.push("/renew");
        }
      }else if(["10"].some(value => authjson.includes(value))){
        this.$router.push("/concealed_accounts");
      }else if(["12","12-1","12-2","12-3","12-4","12-5"].some(value => authjson.includes(value))){
        this.$router.push("/kycManage");
      }else if(["13","13-1","13-2","13-3","13-4","13-5","13-6"].some(value => authjson.includes(value))){
        // this.$router.push("/renew");
      }
      // ---
      if(ind!=3){
        if(["3","3-1","3-2","3-3","3-4","3-5","3-6","3-7"].some(value => authjson.includes(value))){
          if(["3","3-1","3-2","3-3","3-4"].some(value => authjson.includes(value))){
            this.$router.push("/blockchain_d/deposit_fiat");
          }else if(["3-5","3-6","3-7"].some(value => authjson.includes(value))){
            this.$router.push("/blockchain_d/deposit_jmhb");
          }
        }
      }else if(ind!=4){
        if(["4","4-1","4-2","4-3","4-4","4-5","4-6","4-7","4-8"].some(value => authjson.includes(value))){
          this.$router.push("/cards_view");
      }
      }else if(ind!=11){
        if(["11","11-1","11-2","11-3","11-4","11-5","11-6","11-7","11-8","11-9","11-10"].some(value => authjson.includes(value))){
          if(["11","11-1","11-2","11-3","11-4","11-5"].some(value => authjson.includes(value))){
            this.$router.push("/blockchain_w/transfer_p_fiat");
          }else if(["11-6","11-7","11-8","11-9","11-10"].some(value => authjson.includes(value))){
            this.$router.push("/blockchain_w/transfer_p_jmhb");
          }
        }
      }
      
    },
    for_pwd_btn() {
      this.email_addr = "";
      this.for_pwd_dlg = true;
    },
    confirm_btn_fun() {
      if (this.email_addr == "") {
        this.message.ismessage("error", this.$t("main.text191"));
        return false;
      }
      sendEmail({
        email: this.email_addr,
        type: "forgetLoginPassword",
      }).then((res) => {
        if (res.data.code == 207) {
          this.message.ismessage("success", res.data.msg);
          this.for_pwd_dlg = false;
        } else {
          this.message.ismessage("error", res.data.msg);
        }
      });
    },
    lang_fun(v) {
      localStorage.setItem("language", v);
      setTimeout(() => {
        location.reload();
      }, 100);
    },
    // ----
    qrcodeRender() {
      this.$refs.qrcode1.innerHTML = "";
      new QRCode(this.$refs.qrcode1, {
          width: 260,//220
          height: 260,
          text: `otpauth://totp/${this.form.email}@${window.location.hostname}?secret=${this.google_secret}`, // 二维码内容
          colorDark: "#000",//#000 #fff
          colorLight: "#fff",//transparent
          correctLevel: QRCode.CorrectLevel.H,
      });
    },
    //复制
    copy_api(v) {
      const input = document.createElement("input");
      document.body.appendChild(input);
      input.setAttribute("value", v);
      input.select();
      if (document.execCommand("copy")) {
          document.execCommand("copy");
      }
      document.body.removeChild(input);
      this.message.ismessage('success',this.$t('main.text297'));
    },
    login_btn_sbmt(){
      if(!this.google_code){
        return this.message.ismessage('error',this.$t('main.text677'));
      }
      // 谷歌令牌 登陆
      account_verify({
        password:md5(this.form.pwd),
        email:this.form.email,
        google_code: (this.google_code+"")
      }).then(res=>{
        if(res.data.code==200){
          this.message.ismessage('success',this.$t('main.text195'));
          if(!localStorage.getItem("language")) {
            localStorage.setItem("language", 'en');
          }

          // 手机号 国家码
          localStorage.setItem("feb_phone_cc", res.data.data.phone_cc);
          localStorage.setItem("feb_phone_num", res.data.data.phone_num);

          sessionStorage.setItem("token", res.data.data.token);
          sessionStorage.setItem("userid", res.data.data.userid);
          sessionStorage.setItem("username", res.data.data.username);
          sessionStorage.setItem("userType", res.data.data.userType);
          sessionStorage.setItem('is_google',true);

          if(res.data.data.authjson){
            sessionStorage.setItem("authjson", JSON.stringify(res.data.data.authjson));
          }else{
            const arr = [
              "1","1-1","1-2","1-3","1-4",
              "2","2-1","2-2","2-3","2-4","2-5","2-6",
              "3","3-1","3-2","3-3","3-4","3-5","3-6","3-7",
              "4","4-1","4-2","4-3","4-4","4-5","4-6","4-7","4-8",
              "5",
              "6",
              "7",
              "8",
              "9","9-1","9-2","9-3","9-4","9-5","9-6","9-7","9-8","9-9","9-10","9-11","9-12","9-13","9-14","9-15","9-16","9-17","9-18","9-19",
              "10",
              "11","11-1","11-2","11-3","11-4","11-5","11-6","11-7","11-8","11-9","11-10",
              "12","12-1","12-2","12-3","12-4","12-5",
              "13","13-1","13-2","13-3","13-4","13-5","13-6"
            ];
            sessionStorage.setItem("authjson", JSON.stringify(arr));
          }

          // change_kyc_switch:1/0,//修改kyc开关;1开;0关
          sessionStorage.setItem("change_kyc_switch", res.data.data.change_kyc_switch);

          // kyc_status: KYC状态 0没有 1保存未提交 2 待审核   3一审通过  4审核通过  5审核失败
          // 4审核通过 路由才能跳转
          sessionStorage.setItem("kyc_status", res.data.data.kyc_status);

          //邮箱
          sessionStorage.setItem("u_email", res.data.data.email);

          // approve_status: 认证状态 0 没有 1待审核 2审核通过 3审核失败
          // 0 3 需要上传才能进入首页
          localStorage.setItem("approve_status", res.data.data.approve_status);
          
          if (
            res.data.data.approve_status == 0 ||
            res.data.data.approve_status == 3
          ) {
            this.$router.push("/upload");
          } else {
            if(res.data.data.userType == 1){
              this.$router.push("/");
            }else{

              // // 权限
              const authjson = JSON.parse(res.data.data.authjson);
              const authjson_0 = JSON.parse(res.data.data.authjson)[0];
              const kyc_status = res.data.data.kyc_status;
              if(["1","1-1","1-2","1-3","1-4"].includes(authjson_0)){
                this.$router.push("/");
              }else if(["2","2-1","2-2","2-3","2-4","2-5","2-6"].includes(authjson_0)){
                this.$router.push("/my_transaction");
              }else if(["3","3-1","3-2","3-3","3-4","3-5","3-6","3-7"].includes(authjson_0)){
                if(kyc_status==4){
                  if(["3","3-1","3-2","3-3","3-4"].some(value => authjson.includes(value))){
                    this.$router.push("/blockchain_d/deposit_fiat");
                  }else if(["3-5","3-6","3-7"].some(value => authjson.includes(value))){
                    this.$router.push("/blockchain_d/deposit_jmhb");
                  }
                }else{
                  this.Subset_comparison(kyc_status,authjson,"3");
                }
              }else if(["4","4-1","4-2","4-3","4-4","4-5","4-6","4-7","4-8"].includes(authjson_0)){
                if(kyc_status==4){
                  this.$router.push("/cards_view");
                }else{
                  this.Subset_comparison(kyc_status,authjson,"4");
                }
              }else if(["5"].includes(authjson_0)){
                this.$router.push("/otc");
              }else if(["6"].includes(authjson_0)){
                this.$router.push("/private_b_p");
              }else if(["7"].includes(authjson_0)){
                this.$router.push("/structured_p");
              }else if(["8"].includes(authjson_0)){
                this.$router.push("/investment_b");
              }else if(["9","9-1","9-2","9-3","9-4","9-5","9-6","9-7","9-8","9-9","9-10","9-11","9-12","9-13","9-14","9-15","9-16","9-17","9-18","9-19"].includes(authjson_0)){
                if(["9","9-1","9-2","9-3","9-4"].some(value => authjson.includes(value))){
                  this.$router.push("/contract_management");
                }else if(["9-5","9-6","9-7","9-8","9-9","9-10","9-11","9-12","9-13","9-14","9-15","9-16","9-17","9-18","9-19"].some(value => authjson.includes(value))){
                  this.$router.push("/card_management");
                }else if(["12","12-1","12-2","12-3","12-4","12-5"].some(value => authjson.includes(value))){
                  this.$router.push("/kycManage");
                }else if(["13","13-1","13-2","13-3","13-4","13-5","13-6"].some(value => authjson.includes(value))){
                  // this.$router.push("/renew");
                }
              }else if(["10"].includes(authjson_0)){
                this.$router.push("/concealed_accounts");
              }else if(["11","11-1","11-2","11-3","11-4","11-5","11-6","11-7","11-8","11-9","11-10"].includes(authjson_0)){
                if(kyc_status==4){
                  if(["11","11-1","11-2","11-3","11-4","11-5"].some(value => authjson.includes(value))){
                    this.$router.push("/blockchain_w/transfer_p_fiat");
                  }else if(["11-6","11-7","11-8","11-9","11-10"].some(value => authjson.includes(value))){
                    this.$router.push("/blockchain_w/transfer_p_jmhb");
                  }
                }else{
                  this.Subset_comparison(kyc_status,authjson,"11");
                }
              }else if(["12","12-1","12-2","12-3","12-4","12-5"].includes(authjson_0)){
                this.$router.push("/kycManage");
              }else if(["13","13-1","13-2","13-3","13-4","13-5","13-6"].includes(authjson_0)){
                // this.$router.push("/renew");
              }
            }
          }
        }else{
          return this.message.ismessage('error',res.data.msg);
        }
      })

    },




  },
};
</script>

<style scoped>
.login_f_box {
  position: relative;
  width: 100%;
  min-height: 100vh;
  height: 100%;
  background: url(../../assets/img/login_lift_bgc_bgc_new.png) no-repeat;
  background-size: cover;
}

.login {
  position: absolute;
  width: 80%;
  /* min-height: 100vh; */
  height: 80%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.login_box {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
}
/* .login_box > div {
  width: 50%;
  height: 100%;
} */
.left {
  background: url(../../assets/img/login_lift_bgc_new.png) no-repeat;
  background-size: cover;
  color: #fff;
  position: relative;
  width: 55%;
}
.left_box {
  width: 100%;
  /* text-align: center; */
  position: absolute;
  left: 0;
  top: 28%;
  /* transform: translate(-50%, -50%); */
}
.left_logo {
  width: 30%;
  margin-bottom: 20px;
}
.left_img {
  width: 65%;
}
.left_footer {
  margin-top: 20px;
  max-width: 60%;
  /* margin: auto; */
  box-sizing: border-box;
  /* padding-top: 20px; */
  padding-left: 10%;
}
.left_footer1 {
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  margin-bottom: 30px;
}
.left_footer2 {
  font-style: normal;
  /* font-weight: bold; */
  font-size: 18px;
  line-height: 22px;
}

.right {
  position: relative;
  width: 45%;
  overflow-y: auto;
  background: #fff;
}
.tit_top {
  text-align: right;
  color: #314869;
  margin-top: 28px;
  margin-right: 100px;
}
.tit_top_jp {
  text-align: right;
  color: #314869;
  margin-top: 28px;
  margin-right: 62px;
}

.tit_top_span {
  opacity: 0.6;
}

.reg_btn {
  border: 1.5px solid rgba(49, 72, 105, 0.2);
  box-sizing: border-box;
  border-radius: 4px;
  padding: 8px 20px;
  cursor: pointer;
  margin-left: 10px;
}
.form_box {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 70%;
}
@media screen and (max-height: 780px) {
  .form_box {
    position: unset;
    left: 0;
    top: 0;
    transform: inherit;
    width: 70%;
    margin: 20px auto 0;
  }
}

.form_tit {
  color: #314869;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
}
.for_pwd {
  text-align: right;
  color: #deb981;
  font-size: 15px;
  /* text-decoration: underline; */
}
.for_pwd span {
  cursor: pointer;
  border-bottom: 1.5px solid #deb981;
}
.code_w {
  display: flex;
}
.code_w2 {
  width: 60%;
}
.code_w3 {
  margin-left: 16px;
  border: 1.5px solid rgba(49, 72, 105, 0.1);
  border-radius: 4px;
  flex: 1;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.code_w3 span {
  background: #000;
  height: 85%;
  line-height: 32px;
  border-radius: 5px;
  padding: 0 12px;
  font-size: 18px;
  display: inline-block;
  letter-spacing: 8px;
}
.login_btn,
.login_btn:hover {
  width: 100%;
  height: 48px;
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-color: #f1c788;
  border-radius: 4px;
  color: #fff;
  margin-top: 10px;
}
.succ_alert {
  background: rgba(48, 211, 167, 0.16);
  color: #266856;
  margin-bottom: 20px;
  /* margin-top: -65px; */
}
.succ_alert >>> .el-alert__title {
  font-size: 15px;
}
.f_icon {
  width: 18px;
  vertical-align: middle;
  /* margin-left: 10px; */
  cursor: pointer;
}
/* ------ */
.dlg_body {
  background: #041e35;
  color: #fff;
}
.d_body {
  box-sizing: border-box;
  padding: 40px 0;
  max-width: 420px;
  margin: auto;
}
.dlg_u_box {
  display: flex;
  align-items: center;
}
.dlg_u1 {
  width: 100px;
  height: 100px;
  border: 2px solid #deb981;
  border-radius: 50%;
}
.dlg_u2,
.dlg_u2:hover {
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border: none;
  border-radius: 4px;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  color: #04182a;
  margin-left: 40px;
  margin-bottom: 8px;
}
.dlg_u3 {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  margin-left: 40px;
}
.dlg_form {
  margin-top: 25px;
}
.dlg_form >>> .el-form-item__label {
  line-height: 30px;
  color: #fff;
  padding: 0;
}
.cancel_btn {
  color: #f1c788;
  border-color: #f1c788;
  background: transparent;
}
.confirm_btn {
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  color: #04182a;
  border-color: #f1c788;
  margin-left: 20px;
}
.login >>> .el-form--label-top .el-form-item__label {
  color: #5a6d87;
  display: block;
  line-height: inherit;
  margin-bottom: 0px;
  padding-bottom: 8px;
}
.show-pwd {
  position: absolute;
  right: 10px;
  top: 1px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
}
.show-pwd img {
  width: 18px;
}
.login >>> .el-form-item {
  margin-bottom: 20px;
}

/* 语言切换 */
.lan_icon {
  width: 28px;
  height: 28px;
  vertical-align: middle;
  cursor: pointer;
}
.top_right_box1 {
  margin-right: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
}
.u_r_icon2 {
  margin-left: 8px;
  cursor: pointer;
  margin-top: 5px;
}
.lan_list_item {
  cursor: pointer;
  /* width: 28px;
  height: 28px; */
  margin: 10px auto;
  display: block;
}
.head_title2 {
  /* max-width: 70%; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.top_right_box1 > span {
  /* border: 1px solid rgba(49, 72, 105, 0.2); */
  box-sizing: border-box;
  padding: 2px 6px;
  border-radius: 4px;
}

/* ------ */
</style>

<style scoped>
/* 令牌 */
.ewm_box{
  font-style: normal;
  font-weight: 700;
  text-align: center;
  color: #5a6d87;
  width: 70%;
  margin: auto;
  margin-top: 20px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.ewm_box1{
  font-weight: 700;
  font-size: 20px;
  line-height: 26px;
  margin-bottom: 5px;
}
.ewm_box2{
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 15px;
}
.ewm_box4{
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  /* color: #BBBBBB; */
  margin: 10px 0;
  word-break: break-word;
}
.ewm_ody{
  display: inline-block;
  /* border: 2px solid #fff; */
}
.qrcode_secret{
  font-size: 14px;
  line-height: 18px;
  /* color: #BBBBBB; */
  margin: 15px 0;
}
.qrcode_secret span{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 68%;
  display: inline-block;
}
.qrcode_secret img{
  cursor: pointer;
  margin-left: 5px;
  width: 15px;
}
.label_box{
  text-align: left;
  font-size: 13px;
  margin-bottom: 8px;
  margin-top: 15px;
}
</style>

<style>
/* 语言 */
.top_user {
  color: #fff;
  font-size: 15px;
  background: #03101c;
  box-shadow: 0px 4px 8px #03101c;
  border-radius: 16px;
  border: none;
}
.top_user[x-placement^="bottom"] .popper__arrow,
.top_user[x-placement^="bottom"] .popper__arrow::after {
  display: none;
  border-bottom-color: transparent;
}
.top_user .popper__arrow {
  display: none;
}
.lan_popover {
  min-width: 70px;
  /* transform: translateX(-3px); */
}
/* ---- */
</style>

<style scoped>
/* 手机端 */
@media screen and (max-width: 850px) {
  .left {
    width: 0;
    display: none;
  }
  .right {
    width: 100%;
  }
  .login {
    width: 90%;
    height: 85%;
  }
  .tit_top {
    text-align: center;
    margin-right: auto;
  }
  .succ_alert {
    margin-top: 30px;
  }
  .login_btn, 
  .login_btn:hover{
    margin-bottom: 20px;
  }

}

@media screen and (max-height: 970px) {
  .ewm_box {
    top: 90px;
    transform: translate(-50%, 0);
  }
  .ewm_box_2{
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .login_btn,
  .login_btn:hover{
    margin-bottom: 20px;
  }
}
</style>

<style>
.dlg {
  background: rgb(4, 23, 40) !important;
  color: #fff;
}
.dlg .el-dialog__title {
  color: #fff;
}
.dlg .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
.dlg .el-dialog__body {
  padding: 30px 0;
}
</style>